module.exports = __webpack_public_path__ + "img/ico-up.f729840d.svg";